import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { formatDate } from '../../../utils/dateUtils';

const FilterControls = ({
  filters,
  onFiltersChange,
  cities,
  totalCount,
  filteredCount,
  onClearFilters,
  viewMode,
  onViewModeChange
}) => {
  const statusOptions = [
    { value: 'all', label: 'جميع الحالات' },
    { value: 'active', label: 'نشط' },
    { value: 'inactive', label: 'غير نشط' }
  ];

  const cityOptions = [
    { value: 'all', label: 'جميع المدن' },
    ...cities?.map(city => ({
      value: city?.id,
      label: city?.name?.ar
    }))
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const handleMemberCountChange = (type, value) => {
    onFiltersChange({
      ...filters,
      memberCount: {
        ...filters?.memberCount,
        [type]: parseInt(value) || 0
      }
    });
  };

  const hasActiveFilters = () => {
    return filters?.search || 
           filters?.city !== 'all' || 
           filters?.status !== 'all' ||
           filters?.memberCount?.min > 0 ||
           filters?.memberCount?.max < 1000;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      {/* Top Row - Search and View Toggle */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1 max-w-md">
          <Input
            type="search"
            placeholder="البحث في أسماء الاتحادات الفرعية..."
            value={filters?.search}
            onChange={(e) => handleFilterChange('search', e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="flex items-center space-x-2">
          <div className="flex items-center bg-muted rounded-lg p-1">
            <Button
              variant={viewMode === 'grid' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('grid')}
              iconName="Grid3X3"
              iconSize={16}
              className="px-3"
            >
              شبكة
            </Button>
            <Button
              variant={viewMode === 'table' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => onViewModeChange('table')}
              iconName="List"
              iconSize={16}
              className="px-3"
            >
              جدول
            </Button>
          </div>
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* City Filter */}
        <Select
          label="المدينة"
          options={cityOptions}
          value={filters?.city}
          onChange={(value) => handleFilterChange('city', value)}
        />

        {/* Status Filter */}
        <Select
          label="الحالة"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />

        {/* Member Count Range */}
        <div className="space-y-2">
          <label className="text-sm font-medium text-foreground">عدد الأعضاء</label>
          <div className="flex items-center space-x-2">
            <Input
              type="number"
              placeholder="من"
              value={filters?.memberCount?.min || ''}
              onChange={(e) => handleMemberCountChange('min', e?.target?.value)}
              className="flex-1"
            />
            <span className="text-muted-foreground">-</span>
            <Input
              type="number"
              placeholder="إلى"
              value={filters?.memberCount?.max === 1000 ? '' : filters?.memberCount?.max}
              onChange={(e) => handleMemberCountChange('max', e?.target?.value || 1000)}
              className="flex-1"
            />
          </div>
        </div>

        {/* Clear Filters */}
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={onClearFilters}
            disabled={!hasActiveFilters()}
            iconName="X"
            iconPosition="left"
            iconSize={16}
            className="w-full"
          >
            مسح الفلاتر
          </Button>
        </div>
      </div>
      {/* Results Summary */}
      <div className="flex items-center justify-between pt-2 border-t border-border">
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          <span>
            عرض {filteredCount} من أصل {totalCount} اتحاد فرعي
          </span>
          {hasActiveFilters() && (
            <div className="flex items-center space-x-2">
              <Icon name="Filter" size={16} />
              <span>تم تطبيق فلاتر</span>
            </div>
          )}
        </div>

        {filteredCount > 0 && (
          <div className="text-sm text-muted-foreground">
            آخر تحديث: {formatDate(new Date())}
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterControls;